export const methods = [
  {
    id: "qqoqccp",
    title: "Méthode QQOQCCP",
    icon: "❓",
    shortDesc: "Structure ton projet avec des questions fondamentales.",
    description: "QQOQCCP est l’acronyme de Qui, Quoi, Où, Quand, Comment, Combien, Pourquoi. Cette méthode permet d’organiser un projet en s’assurant que tous les aspects de base ont été abordés.",
    usage: "Projets simples à moyens. Éducation, clubs, événements.",
    advantages: [
      "Simple à comprendre et utiliser",
      "Approche pédagogique",
      "Rapide à mettre en place"
    ],
    disadvantages: [
      "Peu adaptée aux projets complexes",
      "Pas d'outils d’analyse ou de suivi avancé"
    ],
    levels: ["normal", "avance", "expert"]
  },
  {
    id: "smart",
    title: "Méthode SMART",
    icon: "🎯",
    shortDesc: "Définis des objectifs spécifiques et mesurables.",
    description: "SMART est un acronyme pour Spécifique, Mesurable, Atteignable, Réaliste, Temporel. Elle permet de fixer des objectifs clairs, suivables et atteignables dans le temps.",
    usage: "Fixation d'objectifs individuels ou collectifs.",
    advantages: ["Objectifs clairs", "Favorise l’atteinte de résultats"],
    disadvantages: ["Moins utile pour la planification complète"],
    levels: ["normal", "avance", "expert"]
  },
  {
    id: "swot",
    title: "Analyse SWOT",
    icon: "📊",
    shortDesc: "Analyse les forces, faiblesses, opportunités et menaces.",
    description: "SWOT est une méthode d’analyse stratégique qui identifie les Forces, Faiblesses, Opportunités et Menaces liées à un projet. Elle est souvent utilisée pour poser un diagnostic global.",
    usage: "Diagnostic stratégique, innovation, lancement.",
    advantages: ["Vision globale du projet", "Anticipation des risques"],
    disadvantages: ["Reste subjectif sans données concrètes"],
    levels: ["normal", "avance", "expert"]
  },
  {
    id: "cycle",
    title: "Cycle de projet (5 étapes)",
    icon: "🔁",
    shortDesc: "Suit le cycle de vie complet d’un projet.",
    description: "Cette méthode décompose un projet en 5 grandes phases : Idéation, Conception, Réalisation, Évaluation, Capitalisation. Elle assure une continuité et un suivi complet du projet.",
    usage: "Projets structurés à moyen ou long terme.",
    advantages: ["Clarté dans les étapes", "Logique chronologique"],
    disadvantages: ["Rigidité si imprévus"],
    levels: ["normal", "avance", "expert"]
  },
  {
    id: "gantt",
    title: "Diagramme de Gantt",
    icon: "📅",
    shortDesc: "Visualise les tâches du projet sur une ligne de temps.",
    description: "Le diagramme de Gantt permet de représenter visuellement les différentes tâches d’un projet sur un calendrier. Chaque barre représente une durée d’exécution.",
    usage: "Suivi de tâches, échéances, projets collectifs.",
    advantages: ["Vision claire du planning", "Coordination d’équipe"],
    disadvantages: ["Besoin de rigueur dans les dates"],
    levels: ["normal", "avance", "expert"]
  },
  {
    id: "raci",
    title: "Méthode RACI",
    icon: "📌",
    shortDesc: "Répartis les rôles dans le projet (R/A/C/I).",
    description: "RACI est un acronyme pour Responsible, Accountable, Consulted, Informed. Cette méthode clarifie qui fait quoi dans un projet et limite les doublons ou oublis de responsabilité.",
    usage: "Répartition de responsabilités, projets d’équipe.",
    advantages: ["Clarifie les rôles", "Évite les doublons"],
    disadvantages: ["Moins adapté aux projets personnels"],
    levels: ["normal", "avance", "expert"]  
  },
  {
    id: "designthinking",
    title: "Design Thinking",
    icon: "💡",
    shortDesc: "Invente et teste des solutions centrées sur l’utilisateur.",
    description: "Le Design Thinking repose sur cinq étapes : empathie, définition, idéation, prototypage, test. Elle vise à résoudre un problème en partant des besoins réels des utilisateurs.",
    usage: "Innovation, pédagogie active, résolution de problèmes.",
    advantages: ["Créativité boostée", "Approche empathique"],
    disadvantages: ["Demande plus de temps et d’agilité"],
    levels: ["normal", "avance", "expert"]
  }
];
